import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import HomeIcon from '@mui/icons-material/Home';
import Style from '../Styles/AppbarStyle'
import FeedIcon from '@mui/icons-material/Feed';
import SubscribersDropdown from './SubscribersDropdown'
import TuneIcon from '@mui/icons-material/Tune';
import CircularProgress from '../../CircularProgress/CircularProgress';
import FilterListIcon from '@mui/icons-material/FilterList';
import ShoppingCartButton from './ShoppingCartButton';
import AddedToCartDialogComponent from '../../AddedToCartDialog/AddedToCartDialogComponent'
import MediaQuery from '../../../../../CommonComponents/UseMediaQuery/MediaQueryComponent'
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import LeftMenuDrawer from './LeftMenuDrawer'

import {
  Link
} from "react-router-dom";

export default function ButtonAppBar(props) {
  const classes = Style();
  const [showSearches, setShowSearches] = React.useState(false)
  const [showFiltersSearch, setShowFiltersSearch] = React.useState(false)
  const componentConstants = {
      ...props.componentConstants
  }

  const componentMethods = {
      ...props.componentMethods
  }

  const componentProps = {
      ...props.componentProps
  }
  
  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="fixed">
        <AddedToCartDialogComponent componentConstants={componentConstants} componentMethods={componentMethods} componentProps={componentProps} />
        <Toolbar>
        <LeftMenuDrawer componentConstants={componentConstants} componentMethods={componentMethods} componentProps={componentProps} />

        <MediaQuery 
          lg={<a href="/" style={classes.link}>
          <Button variant="outlined" color="secondary" component="span" startIcon={<HomeIcon />}>
              {componentConstants.language.LANG_HOME}
          </Button>
        </a>} 
          sm={<a href="/" style={classes.link}>
          <IconButton>
            <HomeIcon color="secondary"/>
          </IconButton>
        </a>} 
          xs={<a href="/" style={classes.link}>
            <IconButton>
              <HomeIcon color="secondary"/>
            </IconButton>
        </a>} 
          md={<a href="/" style={classes.link}>
          <IconButton>
            <HomeIcon color="secondary"/>
          </IconButton>
        </a>} 
          xl={<a href="/" style={classes.link}>
          <Button variant="outlined" color="secondary" component="span" startIcon={<HomeIcon />}>
              {componentConstants.language.LANG_HOME}
          </Button>
        </a>}  />
        {!componentMethods.getLocalStorage('user') ?
        <MediaQuery 
            lg={<Link to="/create-account" style={classes.link}><Button variant="outlined" className={classes.button} color="secondary" component="span" startIcon={<PersonAddIcon />}>
            {componentConstants.language.LANG_CREATE_ACCOUNT}
        </Button></Link>} 
            sm={<Link to="/create-account" style={classes.link}><IconButton aria-label="delete" className={classes.button}>
            <PersonAddIcon color="secondary" />
          </IconButton></Link>} 
            xs={<Link to="/create-account" style={classes.link}><IconButton aria-label="delete" className={classes.button}>
            <PersonAddIcon color="secondary" />
          </IconButton></Link>} 
            md={<Link to="/create-account" style={classes.link}><IconButton aria-label="delete" className={classes.button}>
            <PersonAddIcon color="secondary" />
          </IconButton></Link>} 
            xl={<Link to="/create-account" style={classes.link}><Button variant="outlined" className={classes.button} color="secondary" component="span" startIcon={<PersonAddIcon />}>
            {componentConstants.language.LANG_CREATE_ACCOUNT}
        </Button></Link>}  />
        :
        null}
        {!componentMethods.getLocalStorage('user') ?
        <MediaQuery 
            lg={<Link to="/login" style={classes.link}><Button variant="outlined" className={classes.button} color="secondary" component="span" startIcon={<AccountCircleIcon />}>
            {componentConstants.language.LANG_AUTHENTICATE}
        </Button></Link>} 
            sm={<Link to="/login" style={classes.link}><IconButton aria-label="delete" className={classes.button}>
            <AccountCircleIcon color="secondary" />
          </IconButton></Link>} 
            xs={<Link to="/login" style={classes.link}><IconButton aria-label="delete" className={classes.button}>
            <AccountCircleIcon color="secondary" />
          </IconButton></Link>} 
            md={<Link to="/login" style={classes.link}><IconButton aria-label="delete" className={classes.button}>
            <AccountCircleIcon color="secondary" />
          </IconButton></Link>} 
            xl={<Link to="/login" style={classes.link}><Button variant="outlined" className={classes.button} color="secondary" component="span" startIcon={<AccountCircleIcon />}>
            {componentConstants.language.LANG_AUTHENTICATE}
        </Button></Link>}  />
        :
        null
        }
        {!componentMethods.getLocalStorage('user') ?
          null
          :
          <MediaQuery 
              lg={<Link to="/your-account" style={classes.link}><Button variant="outlined" className={classes.button} color="secondary" component="span" startIcon={<AccountBoxIcon />}>
              {componentConstants.language.LANG_YOUR_ACCOUNT}
          </Button></Link>} 
              sm={<Link to="/your-account" style={classes.link}><IconButton aria-label="delete" className={classes.button}>
              <AccountBoxIcon color="secondary" />
            </IconButton></Link>} 
              xs={<Link to="/your-account" style={classes.link}><IconButton aria-label="delete" className={classes.button}>
              <AccountBoxIcon color="secondary" />
            </IconButton></Link>} 
              md={<Link to="/your-account" style={classes.link}><IconButton aria-label="delete" className={classes.button}>
              <AccountBoxIcon color="secondary" />
            </IconButton></Link>} 
              xl={<Link to="/your-account" style={classes.link}><Button variant="outlined" className={classes.button} color="secondary" component="span" startIcon={<AccountBoxIcon />}>
              {componentConstants.language.LANG_YOUR_ACCOUNT}
          </Button></Link>}  />
        }
        <ShoppingCartButton componentConstants={componentConstants} componentMethods={componentMethods} componentProps={componentProps} />
        </Toolbar>
      </AppBar>
    </Box>
  );
}